export default [
  {
    path: '/tax/:key?',
    name: 'taxPage',
    component: () => import(/*webpackChunkName:'tax'*/ '@/views/tax/index.vue'),
    meta: {},
  },
];
